"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECTION_LEVEL = void 0;
var SECTION_LEVEL;
(function (SECTION_LEVEL) {
    SECTION_LEVEL["top"] = "top";
    SECTION_LEVEL["middle"] = "middle";
    SECTION_LEVEL["bottom"] = "bottom";
})(SECTION_LEVEL = exports.SECTION_LEVEL || (exports.SECTION_LEVEL = {}));
//# sourceMappingURL=Section.js.map